export const Options = {
    AcademicDegree: [
        "Bachelor",
        "Master",
        "Diplom",
        "Magister",
        "Promotion",
        "1. Staatsexamen",
        "2. Staatsexamen",
    ],

    ScoolEducation: [
        "Abitur/Hochschulreife",
        "Fachhochschulreife",
        "Hauptschulabschluss",
        "Mittlere Reife",
    ],

    WorkExperience: [
        "0-2 Jahre",
        "3-5 Jahre",
        "6-10 Jahre",
        "> 10 Jahre",
    ],

    AcademicTitle: [
        "Dr.",
        "Mag.",
        "Prof.",
        "Prof. Dr.",
    ],

    Salutation: [
        { text: "Frau", value: "f" },
        { text: "Herr", value: "m" },
        { text: "Divers", value: "d" },
    ],

    PreferredLocation: [
        "Berlin",
        "Düsseldorf",
        "Frankfurt am Main",
        "München",
        "Brüssel",
        "London",
    ],

    ApplicationFor: [
        "Praktikum",
        "Referendariat",
        "Wissenschaftliche Mitarbeiter",
        "Projektbezogene juristische Mitarbeiter",
        "Anstellung Rechtsanwalt",
    ],

    /**
     * Präferierter Bereich
     * (Alle Änderungen müssen in der Api nachgezogen werden.)
    */
    FieldOfActivity: [
        "Keine Präferenz",
        "Arbeitsrecht",
        "Bank- und Kapitalmarktrecht, Bankaufsicht",
        "Dispute Resolution",
        "Finanzierung",
        "Gesellschaftsrecht",
        "Gewerblicher Rechtsschutz, IT",
        "Kartellrecht, Fusionskontrolle",
        "Mergers & Acquisitions",
        "Öffentliches Recht, Wirtschaftsrecht, Regulierung",
        "Steuerrecht",
    ],

    StudyStatus: [
        "Vor 1. Staatsexamen",
        "Nach 1. Staatsexamen",
        "Nach 2. Staatsexamen",
        "abgeschlossen",
    ],

    Doctorate: [
        "in Arbeit",
        "abgeschlossen",
        "keine Promotion"
    ],

    MasterOfLaws: [
        "in Arbeit",
        "abgeschlossen",
        "kein LL.M."
    ],

    Universities: [
        "Universität Augsburg",
        "Universität Bayreuth",
        "EBS Universität für Wirtschaft und Recht (Privatuniversität)",
        "Freie Universität Berlin",
        "Humboldt-Universität zu Berlin",
        "Universität Bielefeld",
        "Ruhr-Universität Bochum",
        "Rheinische Friedrich-Wilhelms-Universität Bonn",
        "Universität Bremen",
        "Heinrich-Heine-Universität Düsseldorf",
        "Friedrich-Alexander-Universität Erlangen-Nürnberg",
        "Johann-Wolfgang-Goethe-Universität Frankfurt am Main",
        "Europa-Universität Viadrina Frankfurt (Oder)",
        "Albert-Ludwigs-Universität Freiburg",
        "Justus-Liebig-Universität Gießen",
        "Georg-August-Universität Göttingen",
        "Universität Greifswald",
        "Fernuniversität in Hagen",
        "Martin-Luther-Universität Halle-Wittenberg",
        "Universität Hamburg",
        "Bucerius Law School (Privatuniversität)",
        "Gottfried Wilhelm Leibniz Universität Hannover",
        "Ruprecht-Karls-Universität Heidelberg",
        "Friedrich-Schiller-Universität Jena",
        "Christian-Albrechts-Universität zu Kiel",
        "Universität zu Köln",
        "Universität Konstanz",
        "Universität Leipzig",
        "Johannes Gutenberg-Universität Mainz",
        "Universität Mannheim",
        "Philipps-Universität Marburg",
        "Ludwig-Maximilians-Universität München",
        "Westfälische Wilhelms-Universität Münster",
        "Universität Osnabrück",
        "Universität Passau",
        "Universität Potsdam",
        "Universität Regensburg",
        "Universität des Saarlandes",
        "Universität Trier",
        "Eberhard Karls Universität Tübingen",
        "Julius-Maximilians-Universität Würzburg",
    ]
}
